import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {Hint} from 'components/ui-kit/Hint';
import {Modal} from 'components/ui-kit/Modal';
import {ContentContainer} from 'components/ui-kit/PageComponents';
import {breakpoint, colors} from 'theme';

export const Container = styled(ContentContainer)`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px;
    background: ${colors.white};
    border-radius: 8px;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    margin-bottom: 16px;
`;

export const HeaderActions = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
`;

export const Title = styled.h2`
    margin: 0;
    color: ${colors.textPrimary};
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
`;

export const FieldsGrid = styled.div`
    display: grid;
    gap: 18px 24px;

    @media (min-width: ${breakpoint.tablet}) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
`;

export const AddressField = styled.div`
    @media (min-width: ${breakpoint.tablet}) {
        grid-column: span 3;
        min-width: 300px;
        width: 50%;
    }
`;

export const Field = styled(Hint)`
    display: flex;
    flex-direction: column;

    > span {
        padding-bottom: 6px;
        color: ${colors.textSecondary};
        font-size: 12px;
        line-height: 16px;
    }
`;

export const EmployeesHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin: 8px 0;
`;

export const EmployeesTitle = styled.h3`
    margin: 0;
    color: ${colors.textPrimary};
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
`;

export const EmployeesTableWrapper = styled.div`
    min-height: 260px;
    overflow: auto;
`;

export const EmptyEmployeesState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-width: 100%;
    min-height: 300px;
    color: ${colors.textPrimary};
    text-align: center;

    path {
        color: transparent;
    }
`;

export const EmptyEmployeesTitle = styled.div`
    color: ${colors.textPrimary};
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    text-transform: uppercase;
`;

export const EmptyEmployeesDescription = styled.div`
    max-width: 430px;
    color: #3e4660;
    font-size: 14px;
    line-height: 22px;
`;

export const ActionCell = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const RemoveEmployeeButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 0;
    background: transparent;
    color: ${colors.danger};
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
`;

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
`;

export const InlineButton = styled(Button)`
    width: auto;

    > span {
        padding: 0 16px;
    }
`;

export const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
`;

export const ConfirmText = styled.div`
    color: ${colors.textPrimary};
    font-size: 14px;
    line-height: 20px;
`;

export const RemoveConfirmationModal = styled(Modal)`
    [data-reach-dialog-content] {
        padding: 0;
        border-radius: 12px;
        box-shadow: 0 12px 32px rgba(52, 52, 52, 0.16);
        overflow: hidden;
    }
`;

export const ConfirmRemoveModalContent = styled.div`
    min-width: 432px;
`;

export const ConfirmRemoveHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 24px;
    border-bottom: 1px solid #ededed;
`;

export const ConfirmRemoveTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    color: ${colors.textPrimary};
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
`;

export const ConfirmRemoveHeaderIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #ffe5e5;
`;

export const ModalCloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
`;

export const WarningMessage = styled.div`
    margin: 16px 24px;
    padding: 12px;
    border: 1px solid #ffa726;
    border-radius: 8px;
    background: #fff4e6;
    color: ${colors.textPrimary};
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;

    p {
        margin: 0;
    }
`;

export const ConfirmRemoveFooter = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: flex-end;
    padding: 20px 24px;
    border-top: 1px solid #ededed;
`;

export const CancelConfirmButton = styled(Button)`
    max-width: 140px;
`;

export const ConfirmDeleteButton = styled(Button)`
    max-width: 140px;
    background-color: #ff5252 !important;
    border-color: #ff5252 !important;
    color: ${colors.white};
`;
